import React, { useEffect, useRef, useState } from 'react';

const LiteYouTubeAutoplay = ({ videoId, start = 0, loop = true, className = '' }) => {
  const wrapperRef = useRef(null);
  const iframeRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const prefersReducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) return;
    const el = wrapperRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActive(true);
          io.disconnect();
        }
      },
      { threshold: 0.25 }, // muat ketika 25% elemen terlihat
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  const src = active
    ? `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&controls=0&rel=0&modestbranding=1&enablejsapi=1&start=${start}${
        loop ? `&loop=1&playlist=${videoId}` : ''
      }`
    : null;

  const onUnmute = () => {
    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'unMute', args: [] }),
        '*',
      );
    }
  };

  return (
    <div
      ref={wrapperRef}
      className={`relative overflow-hidden rounded-xl bg-black ${className}`}
      style={{ aspectRatio: '16 / 9' }}
      aria-label="YouTube video">
      {!active && (
        <img
          src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
          alt="YouTube poster"
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
      )}

      {active && (
        <iframe
          ref={iframeRef}
          title="YouTube player"
          className="absolute inset-0 h-full w-full"
          src={src}
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      )}

      {active && (
        <button
          type="button"
          onClick={onUnmute}
          className="absolute bottom-3 right-3 rounded-full bg-white/90 px-3 py-1 text-xs font-medium">
          Unmute
        </button>
      )}
    </div>
  );
};

export default LiteYouTubeAutoplay;
